import rolesLogin from 'login/Roles'
import router from '@/router'

var roles = {
  support: {
      globalAdmin: 'global_admin',
  },
  global: {
    client: 'client_admin',
    booking: 'booking_admin',
    service: 'service_desk',
    approver: 'booking_approver',
    settings: 'settings_admin'
  },
  site: {
      group: 'group_admin',
      upload: 'upload_admin',
      people: 'people_admin',
      site: 'site_admin',
      reports: "reports_admin",
      hostess: 'hostess_admin'
  },
  employeeGroup: {
    teamManager: 'team_manager'
  }
}

//Create a object from roles without the group "support, global, etc.."
let rolesWithoutGroup = {}
for(const group in roles){
  for(const role in roles[group]){
    rolesWithoutGroup[role] = roles[group][role]
  }
}

//Create a object where the key is the route, and the data is a object of roles from that data
var routePathsWithRoles = {}
router.getRoutes().forEach((route)=>{
  routePathsWithRoles[route.path] = route.meta.roles
})

export default {
  routePathsWithRoles,
  roles,
  rolesWithoutGroup,
  getResponsibleModule(route){
    return rolesLogin.getResponsibleModule(route)
  },
  showRouteLogin(module, menuRoute, clientRoles, clientAdmin) {
    return rolesLogin.showRoute(module, menuRoute, clientRoles, clientAdmin)
  },
  showRoute(menuRoute, clientRoles, clientAdmin){
    if (clientAdmin) return true
    if (!clientRoles) return false

    let isAllowed = false
    let routeToCheck = null
    if(routePathsWithRoles[menuRoute]) {
      routeToCheck = routePathsWithRoles[menuRoute]
    } else {
      let check = true
      let genericRoute = menuRoute.substr(0, menuRoute.lastIndexOf("/") + 1) + '*'
      while(check) {
        if (routePathsWithRoles[genericRoute]) {
          check = false
          routeToCheck = routePathsWithRoles[genericRoute]
        } else {
          genericRoute = genericRoute.split('/').slice(0, -2).join('/') + '/*'
          if(genericRoute === '/*' ){
            check = false
          }
        }
      }
    }

    for (var roleInRoute in routeToCheck) {
      let available = (clientRoles && clientRoles.some(role => role === rolesWithoutGroup[roleInRoute]))
      if (available) {
        isAllowed = true
      }
    }
    return isAllowed
  },
  checkHasSubRoleEditContent(clientRoles, clientAdmin){
    if (clientAdmin) return true
    if (!clientRoles) return false

    let isAllowed = false
    Object.entries(routePathsWithRoles[router.history.current.path]).forEach(entry => {
      const [key, value] = entry;
      let rolesMatch =  []
      clientRoles.forEach( role => {
        if(role === rolesWithoutGroup[key]){
          rolesMatch.push(value)
        }
      })
      if(rolesMatch){
        rolesMatch.forEach((roleMatch) => {
          if((typeof roleMatch === 'object' && roleMatch.edit) || (typeof roleMatch !== 'object' && roleMatch)){
            isAllowed = true
          }
        })
      }
    })
    return isAllowed
  }
}

